import { render, staticRenderFns } from "./PruebasSecciones.vue?vue&type=template&id=c2dbb77c&scoped=true"
import script from "./PruebasSecciones.vue?vue&type=script&lang=js"
export * from "./PruebasSecciones.vue?vue&type=script&lang=js"
import style0 from "./PruebasSecciones.vue?vue&type=style&index=0&id=c2dbb77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dbb77c",
  null
  
)

export default component.exports